import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SiteDetail } from '@classes/site-detail';
import { SiteGridViewItem } from '@classes/site-grid-view-item';
import { SiteService } from 'app/core/services/site.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-site-grid',
  templateUrl: './site-grid.component.html',
  styleUrls: ['./site-grid.component.scss']
})
export class SiteGridComponent implements OnInit, AfterViewInit {

  @Output() siteEmit = new EventEmitter<SiteDetail>();

  dataSource = new MatTableDataSource<SiteGridViewItem>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    'paco'
  ];
  nameFilter = new FormControl('');
  filterValues = {
    name: '',
    onlyPacoCheck: false,
    onlyPacoIndeterminate: true,
  };


  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @ViewChild(MatPaginator, { static: true }) MatPaginatorIndex: MatPaginator;
  @ViewChild('search') searchElement: ElementRef;

  constructor(
    public siteService: SiteService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.getSites();

    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    // this.onlyPacoFilter.valueChanges
    //   .subscribe(
    //     value => {
    //       this.filterValues.onlyPaco = value;
    //       this.dataSource.filter = JSON.stringify(this.filterValues);
    //     }
    //   )
  }

  getSites() {
    this.uiService.addRouteLoading();
    this.siteService.getSites(true).subscribe(sites => {
      this.dataSource.data = sites
        .sort((a, b) => ((a.name || "") > (b.name || "")) ? 1 : (((b.name || "") > (a.name || "")) ? -1 : 0))
        .map(m => new SiteGridViewItem({
          id: m.id,
          name: m.name,
          isPaco: m.isPaco
        }));
      this.dataSource.filter = JSON.stringify(this.filterValues);
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    });
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'paco': return (element.isPaco);
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilter();
  }

  selectItemClick(item: SiteGridViewItem) {
    this.selectedRowID = item.id || '';
    const siteDetail = new SiteDetail({
      id: this.selectedRowID,
      isReadOnlyMode: true
    });
    this.siteEmit.emit(siteDetail);
  }

  onCreateNewSite() {
    const siteDetail = new SiteDetail({
      isCreationMode: true
    });
    this.siteEmit.emit(siteDetail);
  }

  click(filter: any) {
    let indeterminated = (!filter.onlyPacoCheck && !filter.onlyPacoIndeterminate) ? true : false;
    let checked = (!filter.onlyPacoCheck && filter.onlyPacoIndeterminate) ? true : false
    // filter.indeterminated = indeterminated;
    // filter.checked = checked;

    this.filterValues.onlyPacoIndeterminate = indeterminated;
    this.filterValues.onlyPacoCheck = checked;

    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data: { name: string; isPaco: boolean }, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.name) !== -1
        && ((searchTerms.onlyPacoIndeterminate)
          ? true
          : (searchTerms.onlyPacoCheck == data.isPaco)
        );
    }
    return filterFunction;
  }

}

